/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const adoWorkItemStateSummarySchema = z.object({
  category: z.string().nullish(),
  name: z.string(),
});
